import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/trending';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <SectionHeading
          eyebrow="常见问题"
          title="关于榜单、收录与内容原则"
          description="第一次来这里的人问得最多的几个问题，集中回答一下。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-8 lg:gap-12">
          <aside className="bg-background-50 border border-background-200 rounded-lg p-6 h-fit lg:sticky lg:top-24">
            <h3 className="font-heading text-lg font-bold text-foreground-950">内容原则</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600 leading-7">
              <li className="flex gap-2">
                <span className="w-5 h-5 shrink-0 flex items-center justify-center text-primary-500">
                  <i className="ri-check-line" aria-hidden="true"></i>
                </span>
                只整理公开讨论，不做独家爆料
              </li>
              <li className="flex gap-2">
                <span className="w-5 h-5 shrink-0 flex items-center justify-center text-primary-500">
                  <i className="ri-check-line" aria-hidden="true"></i>
                </span>
                涉及个人隐私的话题不予收录
              </li>
              <li className="flex gap-2">
                <span className="w-5 h-5 shrink-0 flex items-center justify-center text-primary-500">
                  <i className="ri-check-line" aria-hidden="true"></i>
                </span>
                热度值只代表讨论量高低
              </li>
              <li className="flex gap-2">
                <span className="w-5 h-5 shrink-0 flex items-center justify-center text-primary-500">
                  <i className="ri-check-line" aria-hidden="true"></i>
                </span>
                发现错误可随时联系我们
              </li>
            </ul>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 text-sm text-primary-700 hover:text-primary-600 transition-colors"
            >
              了解我们的内容原则
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </aside>

          <FaqAccordion items={faqs} />
        </div>
      </div>
    </section>
  );
}